const data = {
    "Main": "Главная",
    "Transportation organization": "Организация перевозок",
    "Dispatching": "Диспетчеризация",
    "Sales": "Продажи",
    "Administration": "Администрирование",
    "Logout": "Выход",
    "Search": "Поиск",

    "Trips": "Рейсы",
    "Reporting": "Отчетность",

    "Logs": "Логи",
    "Cashier action": "Действие кассира",

    "Pricing": "Ценообразование",
    "Tariffs": "Тарифы",
    "Privileges": "Льготы",
    "Baggage": "Багаж",
    "Services": "Услуги",

    "Profile": "Профиль",
    "My profile": "Мой профиль",

    "Sales reporting": "Отчетность по продажам",
    "Dispatch reporting": "Отчетность диспетчеризации",
    "Transporter reports": "Отчеты по перевозчикам",
    "Reports for Min. Trans.": "Отчеты для Мин.Транс.",
    "Reports for Validator.": "Отчет валидаторов",
    "Reversals": "Отчет о возврате",

    "Cashier's workplace": "Рабочее место кассира",
    "Ticket selling": "Продажа билетов",
    "Armor redemption": "Выкуп брони",
    "Ticket return": "Возврат билета",
    "Restore ticket": "Восстановить билета",

    "Schedule": "Расписание",
    "Areas": "Области",
    "Bus terminals": "Автовокзалы",
    "Routes": "Маршруты",
    "Schedule trips": "Рейсы расписания",

    "Settings": "Настройки",
    "Options": "Параметры",
    "Returns": "Возвраты",
    "Booking": "Бронирование",
    "Booking List": "Список броны",
    "Work with transporter": "Работа с перевозчиками",

    "Transporter": "Перевозчик",
    "Buses": "Автобусы",
    "Bus types": "Типы автобусов",

    "Employees": "Сотрудники",
    "Roles": "Роли",

    "Creation - Editing": "Создание - редактирование",
    "Baggage (Editing)": "Багаж (Редактирование)",
    "Save and close": "Записать и закрыть",
    "Fixed amount": "Фиксированная сумма",
    "Interest Amount": "Процентная сумма",
    "Amount depending on km": "Сумма в звисимости от км",
    "Title": "Название",
    "Weight to (kg)": "Вес до (кг)",
    "Step (km)": "Шаг (км)",
    "Additional settings": "Доп.настройки",
    "From (km)": "От (км)",
    "To (km)": "До (км)",
    "Price for this step": "Цена за данный шаг",
    "Price": "Цена",
    "Percent": "Процент",
    "Action": "Действия",
    "Reservation fee": "Доплата за бронирование",
    "bag for a ticket": "сум за билет",
    "It is allowed to book more than 1 place for a cashier": "Разрешено бронировать более 1 места для кассира",
    "Not": "Нет",
    "Passenger personal data required": "Персональные данные пассажира требуются",
    "Required": "Требуются",
    "Not required": "Не требуются",
    "Places are again available for sale for": "Места снова становятся доступны для продажи за",
    "minutes before departure": "минут до отбытия",
    "Booking is removed through": "Бронь снимается через",
    "minutes": "минут",
    "Yes": "Да",
    "No": "Нет",
    "Editing": "Редактирование",
    "Creature": "Создание",
    "buses": "автобусов",
    "This field is required": "Это поле обязательно к заполнению",
    "Model": "Модель",
    "Driver": "Водитель",
    "Generate to finish": "Генерировать до конца",
    "Number bus": "Номер автобуса",
    "Create": "Создать",
    "Transporters": "Перевозчики",
    "Number": "Номер",
    "Status": "Статус",
    "Active": "Активный",
    "Inactive": "Неактивный",
    "Loading": "Загружается",
    "Choose a transporter": "Выберите перевозчик",
    "Choose a bus model": "Выберите модель автобуса",
    "Choose a driver": "Выберите водитель",

    "Creation": "Создание",
    "Types of buses (creation - editing)": "Типы автобусов (создание - редактирование)",
    "How many floors": "Сколько этажей",
    "First floor": "Первый этаж",
    "Second floor": "Второй этаж",
    "Swap From": "Поменять с",
    "Created place": "Созданное место",
    "Created a place for the disabled": "Созданное место для инвалидов",
    "Created place for passengers with children": "Созданное место для пассажиров с детьми",
    "Floors": "Этажность",
    "Create a new type": "Создать новый тип",
    "Users": "Пользователи",
    "Name": "Имя",
    "Phone number": "Номер телефона",
    "Type": "Тип",
    "Status user": "Статус пользователья",
    "Confirm the password": "Потвердите пароль",
    "Select user type": "Выберите тип пользователья",
    "Refresh": "Обновить",
    "Old Password": "Старый пароль",
    "Password": "Пароль",
    "Employee's role": "Роль сотрудника",
    "Add roles": "Добавить роли",
    "New Password": "Новый пароль",
    "Confirmed Password": "Потвердите пароль",
    "Your password has been successfully updated": "Ваш пароль успешно обновлен",
    "Role users": "Роли пользователей",
    "Number of permissions": "Кол-во разрешений",
    "Number of users": "Кол-во пользователей",
    "User Roles (Creation)": "Роли пользователей (создание)",
    "Please select at least one permission": "Пожалуйста, выберите хотя бы одно разрешение",
    "additional trips": "доп. рейсы",
    "Actualize": "Актуализировать",
    "Send trips": "Отправить рейс",
    "Cancel trips": "Отменить рейс",
    "Change trips": "Изменить рейс",
    "Has arrived": "Прибыл",
    "Statement": "Ведомость",
    "List": "Список",
    "Passenger": "Пассажир",
    "Passengers": "Пассажиры",
    "Export to Excel": "Экспорт в Excel",
    "Select": "Выберите",
    "Trip date": "Дата рейсов",
    "Point of departure": "Пункт отправления",
    "Select stations": "Выберите станции",
    "date": "Дата",
    "Capacity": "Вместимость",
    "Number of occupied places": "Кол-во занятых мест",
    "Platform": "Перрон",
    "Amount": "Сумма",
    "trip": "рейс",
    "To send": "Отправить",
    "Bus number": "Номер автобуса",
    "Bus brand": "Марка автобуса",
    "Cancel": "Отменить",
    "Place": "Место",
    "Cost": "Стоимость",
    "You cannot disable this trip because it has active passengers.": "Вы не можете отключить эту поездку, потому что у нее есть активные пассажиры.",
    "STATEMENT": "ВЕДОМОСТЬ",
    "LIST": "СПИСОК",
    "Passengers transported in international road transport": "Пассажиров провозимых в международном автомобильном сообщении",
    "attached to the ticket list": "прилагаемый к билетной ведомости",
    "Date and time of departure": "Дата и время отправления",
    "Bus model": "Модель автобуса",
    "Trip": "Рейс",
    "Issued by": "Выдано",
    "Departure": "Отправление",
    "Number of citizenship": "Количество по гражданству",
    "FULL NAME": "Ф.И.О",
    "Places": "Места",
    "Year of birth": "Год рождения",
    "Passport Series and No.": "Паспорт серия и №",
    "Citizenship": "Гражданство",
    "Until where": "До куда",
    "Ticket price": "Цена билета",
    "": "Билеты",
    "Total amount": "Итоговая сумма",

    "Loading data": "Идет загрузка данных",
    "Route": "Маршрут",
    "Departure time": "Время отправления",
    "Price entry": "Ввод цен",
    "Name ATP": "Название АТП",
    "Bank": "Банк",
    "MFO": "МФО",
    "Checking account": "Рассчетный счет",
    "Percentage per passenger": "Процент за пассажира",
    "Percentage per baggage": "Процент за багаж",
    "Price / km": "Цена / км",
    "Find": "Найти",
    "Locality": "Населенный пункт",
    "Adress": "Адрес",
    "Operation mode": "Режим работы",
    "Coordinates": "Координаты",
    "Place of bus station (optional)": "Место автовокзалы (необязательно)",
    "Also known as": "Также известна как",
    "day": "день",
    "Pre-sale fee": "Сбор за предпродажу",
    "sum": "сум",
    "Presale - for sale for more than": "Предпродажа - продажа более чем за",
    "o'clock": "часов",
    "Reserved seats": "Зарезервированные места",
    "Seats": "Месты",
    "Reserved minutes": "Становятся доступны за",
    "become available for": "становятся доступны за",
    "minutes before sending": "минут до отправки",
    "Customize information board color scheme": "Настройка цветовой схемы информационного табло",
    "Background 1": "Задний фон 1",
    "Text color 1": "Цвет текста 1",
    "Background 2": "Задний фон 2",
    "Text color 2": "Цвет текста 2",
    "Show report": "Показать в отчеты",
    "Schedule Flights (Creation)": "Рейсы расписания (создание)",
    "Choose a route": "Выберите маршрут",
    "Trip number": "Номер рейса",
    "Arrival": "Прибытие",
    "On the way": "В пути",
    "Each": "Каждый",
    "Mon": "Пн",
    "Tu": "Вт",
    "We": "Ср",
    "Th": "Чт",
    "Fr": "Пт",
    "Sa": "Сб",
    "Su": "Вс",
    "Various": "Разные",
    "Even": "Четные",
    "Odd": "Нечетные",
    "For example 1-5, 9, 13": "Например 1-5, 9, 13",
    "Days": "Дни",
    "Beginning with": "Начиная с",
    "Ends at": "Закончено в",
    "Choose a bus": "Выберите автобус",
    "Automatic update": "Автоматическая актуализация",
    "International flight": "Международный рейс",
    "Parking": "Стоянка",
    "Send": "Отпр.",
    "Comment": "Комментарий",
    "Choose a rate": 'Выберите тариф',
    "Flights schedule": "Рейсы расписание",
    "Deactivate": "Деактивировать",
    "Destination": "Пункт назначения",
    "Regularity": "Регулярность",
    "Period": "Период",
    "Turned off": "Выключено",
    "Schedule Flights (Change)": "Рейсы расписания (Изменить)",
    "Change": "Изменить",
    "Clear trail flights and generate new ones": "Очистить след. рейсы и сгенерировать новые",
    "Filter": "Фильтр",
    "- day": "-й день",
    "Route number": "Номер маршрута",
    "Add station": "Добавить станцию",
    "Select a station to add": "Выберите станцию для добавления",
    "Choose": "Выбрать",
    "Km": "Км",
    "Tit.": "Назв.",
    "Fault return": "Возврат по вине",
    "Fine": "Штраф",
    "ATP": "АТП",
    "Passenger after flight departure": "Пассажира после ухода рейса",
    "The return of the fault of the passenger to the departure of the flight": "Возврат по вине пассажира до ухода рейса",
    "Creating benefits": "Создание льгот",
    "Route Name": "Наименование маршрута",
    "Write down": "Записать",
    "Add": "Добавить",
    "Bus terminal": "Автовокзал",
    "Login": "Логин",
    "Enter": "Вход",
    "Location": "Местонахождение",
    "Geography": "География",
    "Prochee": "Другое",
    "Cashiers": "Кассиры",
    "Full name": "Имя фамилия",
    "Passport number": "Номер паспорта",
    "Number place": "Номер места",
    "Trips (creation)": "Рейсы (изменение)",
    "Bus": "Автобус",
    "Region": "Область",
    "Stations" : "Станции",
    "Privilege" : "Привилегии",
    "Return service" : "Возврат услуги",
    "Bus type" : "Тип автобуса",
    'Country': 'Страна',
    'Conductor' : 'Кондуктор',
    'Reports' : 'Отчеты',
    "You are about to delete the record! \nAre you sure?" : 'Вы собираетесь удалить запись! \nВы уверены?',
    "Registration" : "Регистрация",
    "Tariff": "Тариф",
    "Fine (percentage)" : "Штраф(в процентах)",
    "No. ticket" : "№ билета",
    "Role has been saved successfully" : "Роль была успешно сохранена",
    "Select service type" : "Выберите тип услуги",
    "Choose a baggage type" : "Выберите тип багажа",
    "Name trip" : "Название рейса",
    "Choose region" : "Выберите область",
    "Place of residence" : "Адрес прописки",
    "Save" : "Сохранить",
    "Do you really want to delete this bus station?" : "Вы действительно хотите удалить этот автовокзал?",
    "Settings saved!" : "Настройки сохранено!",
    "Depth of sales" : "Глубина продаж",
    "Presale": "Предпродажа",
    "Place quotas" : "Квоты мест",
    "Bus station services" : "Услуги автовокзала",
    "Required " : "Обязательная",
    "Show in reports": "Пок. в отчеты",
    "Bus station collection" : "Сбор автовокзала",
    "All passengers moved to a new journey." : "Все пассажиры переехали в новое путешествие",
    "HOT !!! Do you really want to delete all trips that start tomorrow and generate new ones?" : "ОСТАРОЖНА!!! Вы действительно хотите удалить все поездки, которые начинаются с завтрашнего дня, и генерировать новые? ",
    'Successfully!!!' : 'Успешно!!!',
    'Saved!' : 'Сохранено!',
    'min' : 'мин',
    'h' : 'ч',
    'Basic' : 'Основное',
    'Do you really want to delete flight schedules?' : 'Вы действительно хотите удалить рейс расписания?',
    "You are about to delete the record \nAre you sure?" : "Вы собираетесь удалить запись!\n" +
        "Уверены ли вы?",
    "Surname" : "Фамилия",
    "Middle name" : "Отчество",
    "Do you really want to change the status?" : "Вы действительно хотите изменить статус ?",
    "Changed status" : "Изменено статус",
    "Failed to change" : "Не удалось изменить",
    "Do you really want to delete?" : "Вы действительно хотите удалить?",
    "Departure date" : "Дата отправления",
    "Number of passengers" : "Количество пассажиров",
    "Generate month report" : "Сформировать мес отчет",
    "Generate daily report" : "Сформировать суточный отчет",
    "Filter by date from" : "Фильтр по дате с",
    "by" : "по",
    "To form" : "Сформировать",
    "Car number" : "Номер авто",
    "Count beat" : "Кол. бил",
    "Plan" : "План",
    "Fact" : "Факт",
    "Pass" : "Пас",
    "Bag" : "Баг",
    "Full name of the driver" : "Ф.И.О водителя",
    "Cash" : "Нал",
    "Term" : "Терм",
    "Print out" : "Распечатать",
    "Total": "Итого",
    "Last day" : "За последний день",
    "since the beginning of the week" : "с начало недели",
    "from the beginning of the month" : "с начало месяца",
    "from the beginning of the year" : "с начало года",
    "trips" : "рейсы",
    "passenger" : "пассажир",
    "all places" : "всего мест",
    "Name of the Cashier" : "ФИО Кассира",
    "Sold tickets": "Продано билетов",
    "Including" : "В том числе",
    "Returned tickets" : "Возвращено билетов",
    "Sold tickets with no refund" : "Продано билетов с вычетом возврата",
    "Number of booking.\n places" : "Количество \n брон. \n мест",
    "count" : "кол-во",
    "amount":"сумма",
    "Sold Services" : "Продано услуг",
    "baggage amount" : "багаж сумма",
    "тек" : "тек",
    "Cashier" : "Кассир",
    "All passengers" : "Все пассажиры",
    "Village of passengers" : "Село пассажиров",
    "No passengers" : "Не село пассажиров",
    "Booked seats" : "Забронированно мест",
    "Canceled tickets" : "Отменено билетов",
    "others" : "другие",
    "Selected passengers" : "Выбранный пассажиры",
    "Selected Village of passengers" : "Выбранный Село пассажиров",
    "Selected No passengers village" : "Выбранный Не село пассажиров",
    "Selected Canceled Tickets" : "Выбранный Отменено билетов",
    "Selected Returned Tickets" : "Выбранный Возвращено билетов",
    "Selected others" : "Выбранный Отменено билетовВыбранный другие",
    "Amount of selected passengers" : "Сумма выбранный пассажиров",
    "No reports" : "Нет отчеты",
    "Everything" : "Все",
    "Village" : "Село",
    "Not village" : "Не село",
    "Booked" : "Забронированно",
    "Canceled" : "Отменено",
    "Cancelled" : "Отмененный",
    "Returned" : "Возвращено",
    "other" : "другие",
    "Armored" : "Бронирован",
    "Did not come" : "Не приехал",
    "Had arrived" : "Приехал",
    "Canceled for non-payment" : "Отменил за неуплату",
    "Validators report" : "Отчет валидаторов",
    "Name of Validator" : "ФИО Валидатора",
    "Trip time" : "Время рейса",
    "minimum length is 3" : "минимальное длина равно 3",
    "maximum length is 150" : "максимальное длина равно 150",
    "can only be used" : "можно использовать только",
    "required field" : "поле объязательное",
    "cyrillic letters" : "кирилица буквы",
    "latin letters" : "латинские буквы",
    "Do you really want to delete this flight?" : "Вы действительно хотите удалить этот рейс?",
    "Passenger removed!" : "Пассажир удалено!",
    "Trip has been created successfully" : "Рейс был успешно создана",
    "Arrived" : "Прибывший",
    "You are about to delete the record!\nAre you sure?": "Вы собираетесь удалить запись!\nУверены ли вы?",
    "This stop has already been added to the route." : "Данная остановка уже добавлена в маршрут",
    "Count users" : "Кол-во пользователей",
    "For today" : "На сегодня",

//    infokiosk_web
    "Sale tickets at the price of a bus station": "Продажа билетов по цене автовокзала",
    "Ticket Recovery": "Восстановление билетов",
    "Next": "Далее",
    "Enter phone number": "Введите номер телефона",
    "Submit Code": "Отправить код",
    "Get my tickets": "Получить мои билеты",
    "Data": "Дата",
    "Reys": "Рейс",
    "Ticket": "Билет",
    "No tickets": "Нет билетов",
    "Ministry of Transport of the Republic of Uzbekistan": "Министерство Транспорта Республики Узбекистан",
    "All rights reserved": " Все права защищены",
    "Portal developed": "Портал разработан",
    "There is no train station in this location yet": "В этот локаци пока вокзал нету",
    "Reys on": "РЕЙСЫ НА",
    "reys": "рейс",
    "Reserved places will be cleared through": "Зарезервированные места освободятся через",
    "Free": "Свободно",
    "Busy": "Занято",
    "Reserve": "Резерв",
    "Selected": "Выбрано",
    "Checkout": "Оформление заказа",
    "Phone": "Телефон",
    "E-mail": "E-mail",
    "required fields": "обязательные для заполнения поля",
    "For paying": "К оплате",
    "Payment": "Оплата",
    "Card number": "Номер карты",
    "Card expiry date": "Срок действия карты",
    "Send SMS Code": "Отправить смс-код",
    "Pay": "Оплатить",
    "SMS-CODE": "СМС-КОД",
    "Take a picture or": "Сфотографируйте или",
    "Count empty seats": "Кол. пустых мест",
    "Rate (summa)": "Тариф (сум)",
    "This seat is selected by other user": "Это место выбрано другим пользователем",
    "The bus does not go on the indicated date": "В указанную дату автобус не ходит",
    "Where to": "Куда",
    "When": "Когда",
    "Tashkent": "Ташкент",
    "Tickets": "Билеты",
    "Back": "Назад",
};

export default data;
